import { Stack } from '@mui/material';
import AuditEventsTable from '../organisms/AuditEventsTable';
import { useFlagFixed } from '@hooks';
import { Flag } from '@utils';
import { ProState } from '@components/Packages/ProState';

export function AuditEventsPage() {
  const { isPremium: isPremiumBundlesPage } = useFlagFixed(Flag.UI_BUNDLES);
  return isPremiumBundlesPage ? <ProState /> : <AuditEventsPageContent />;
}

function AuditEventsPageContent() {
  return (
    <Stack direction="column" spacing={2}>
      <AuditEventsTable />
    </Stack>
  );
}
